(function (app, ng) {

    var searchResultDateStructure = {
        Value: {
            Client: {
                ClientStartDate: "date",
                Person: {
                    Dob: "date"
                }
            }
        }
    };

    function datify(obj, structure) {
        if (!obj) return;
        if (ng.isArray(structure)) {
            for (var i = 0; i < obj.length; i++) {
                if (structure[0] === "date" && ng.isString(obj[i]))
                    obj[i] = new Date(obj[i]);
                if (ng.isObject(structure[0]) || ng.isArray(structure[0]))
                    datify(obj[i], structure[0]);
            }
            return;
        }
        if (ng.isObject(structure)) {
            for (var key in structure) {
                if (!structure.hasOwnProperty(key)) continue;
                if (structure[key] === "date" && ng.isString(obj[key]))
                    obj[key] = new Date(obj[key]);
                if (ng.isObject(structure[key]) || ng.isArray(structure[key]))
                    datify(obj[key], structure[key]);
            }
        }
    }

    app.provider("searchApi", [function () {
        this.$get = ["crmApiGateway", function (crmApiGateway) {
            var service = {};

            service.search = function (term) {
                return crmApiGateway.getArray("/Search?q=" + term).then(function (results) {
                    datify(results, [searchResultDateStructure]);
                    return results;
                });
            };

            return service;
        }];
    }]);
})(window.app, window.angular); //jshint ignore:line